import { useEffect, useState } from 'react';
import { AblyConnections } from '../ably-connections';
export const usePubSub = inboxId => {
  const [client, setClient] = useState(() => AblyConnections.getRealtime(inboxId));
  useEffect(() => {
    if (!client) {
      // error handling managed in AblyConnections
      void AblyConnections.connect(inboxId).then(setClient);
    }
    return () => {
      // removeListener will close the connection if there are no remaining connections
      AblyConnections.removeListener(inboxId);
    };
  }, [client, inboxId]);
  return client;
};